import { render, staticRenderFns } from "./HiboTelInput.vue?vue&type=template&id=4fac762a&"
import script from "./HiboTelInput.vue?vue&type=script&lang=ts&"
export * from "./HiboTelInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports